import {Trans} from '../../i18n/trans';
import {Product} from '../product';
import {CheckIcon} from '@common/icons/material/Check';
import clsx from 'clsx';

interface FeatureListProps {
  product: Product;
  variant?: 'default' | 'landing';
}

export function ProductFeatureList({
  product,
  variant = 'default',
}: FeatureListProps) {
  if (!product.feature_list.length) return null;

  return (
    <div
      className={clsx(
        'mt-32 border-t pt-24',
        variant === 'landing' && 'border-white/10',
      )}
    >
      <div className="mb-10 text-sm font-semibold">
        <Trans message="Incluído no plano" />
      </div>
      {product.feature_list.map(feature => (
        <div
          key={feature}
          className={clsx(
            'flex items-center gap-10 py-6 text-sm',
            variant === 'landing' && 'text-white/78',
          )}
        >
          <CheckIcon className="text-primary" size="sm" />
          <Trans message={feature} />
        </div>
      ))}
    </div>
  );
}
